import { apolloClient } from '~/apollo-client';
import {
  Flex_CreateProductLeadMutation,
  Flex_CreateProductLeadMutationVariables,
} from '~/typings/graphql';
import { CREATE_PRODUCT_LEAD } from './create-product-lead.queries';

export interface CreateProductLeadParams {
  planId: number;
  productId: number;
  utilityAccountId: number;
}

export interface CreateProductLeadResponse {
  productLeadId?: number;
}

export const createProductLead = async (
  params: CreateProductLeadParams,
): Promise<CreateProductLeadResponse> => {
  try {
    const response = await apolloClient.mutate<
      Flex_CreateProductLeadMutation,
      Flex_CreateProductLeadMutationVariables
    >({
      mutation: CREATE_PRODUCT_LEAD,
      variables: {
        input: params,
      },
    });
    return {
      productLeadId: response?.data?.createProductLead?.id!,
    };
  } catch (e) {
    // mutation will error if product lead already exists (happens frequently)
    // would be nice to update the API route to not error in this case (idempotent)
    return { productLeadId: undefined };
  }
};
